import { render, staticRenderFns } from "./firstReview.vue?vue&type=template&id=4245839a&scoped=true"
import script from "./firstReview.vue?vue&type=script&lang=js"
export * from "./firstReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245839a",
  null
  
)

export default component.exports